import { Routes } from '@angular/router';
import { ownerGuard } from '../../auth/guards/owner.guard';

export const workspaceRoutes: Routes = [
  {
    path: 'workspaces',
    children: [
      {
        path: ':id/settings',
        canActivate: [ownerGuard],
        loadComponent: () =>
          import('./pages/workspace-page/workspace-page.component').then(
            (m) => m.WorkspacePageComponent,
          ),
      },
    ],
  },
];
